import productApi from "@api/products" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            rejectReasons: false,
            products: false,
            product: false,
            productSave: false,
        },
        errors: {
            rejectReasons: null,
            products: null,
            product: null,
            productSave: null,
        },
        rejectReasons: [],
        products: [],
        product: {},
    },
    getters: {
        rejectReasons: state => state.rejectReasons,
        products: state => state.products,
        product: state => state.product,
        productsReviewLoadingState: state => name => state.loading[name],
        productsReviewErrorState: state => name => state.errors[name],
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        setRejectReasons(state, reasons) {
            Vue.set(state, 'rejectReasons', reasons)
        },
        products(state, products) {
            Vue.set(state, 'products', products)
        },
        product(state, product) {
            Vue.set(state, 'product', product)
        },
        updateProductProperty(state, payload) {
            Vue.set(state.product, payload.property, payload.value)
        },
    },
    actions: {
        loadRejectReasons({ commit }) {
            commit('setLoadingState', { name: 'rejectReasons', value: true })

            productApi.getProductRejectReasons()
                .then(response => {
                    const { data } = response.data
                    commit('setRejectReasons', data)
                })
                .catch(() => {
                    commit('setError', { name: 'rejectReasons', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'rejectReasons', value: false })
                })
        },
        loadProducts({ commit }) {
            commit('setLoadingState', { name: 'products', value: true })

            productApi.getProductsForReview()
                .then(response => {
                    const { data } = response.data
                    commit('products', data)
                })
                .catch(() => {
                    commit('setError', { name: 'products', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'products', value: false })
                })
        },
        loadProduct({ commit }, uuid) {
            commit('setLoadingState', { name: 'product', value: true })

            return productApi.getProduct(uuid)
                .then(response => {
                    const { data } = response.data
                    commit('product', data)
                })
                .catch(() => {
                    commit('setError', { name: 'product', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'product', value: false })
                })
        },
        updateProductStatus({ commit, state }, uuid) {
            commit('setLoadingState', { name: 'productSave', value: true })
            commit('setError', { name: 'productSave', value: false })

            return productApi.updateProductStatus(uuid, state.product)
                .catch(() => {
                    commit('setError', {
                        name: 'productSave',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'productSave', value: false })
                })
        },
        updateProductReviewProperty({ commit }, payload) {
            commit('updateProductProperty', payload)
        },
    },
}
